import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import twoField from "@/extension/h5/two-field"

addCustomWidgetSchema({
  type: 'twoField',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '', // 唯一名称
    defaultValue: '/', // 默认值
    label: '血压',
    labelAlign: 'label-right-align',
    columnWidth: '200px',
    labelWidth: '110',
    required: true,
    disabled: false,
    labelHidden: false,
    readonly: false,
    size: '',
    placeholder: '请输入收缩压',//输入提示文字
    customClass: '',
    requiredHint: '请输入收缩压',
    requiredHint1: '请输入舒张压',
    //-------------------
    placeholder1: '请输入舒张压',
    input1Width: '1',
    input2Width: '1',
    unit1: 'mmHg',
    unit2: 'mmHg',
    //选择项改变事件
    onChange1: '',
    onChange2: '',
    onBlur1: '',
    onBlur2: '',
    inputRegular1: '/^[-]?\\d+(\\.\\d+)?$/',
    inputRegular2: '/^[-]?\\d+(\\.\\d+)?$/',
    onValidate: ''
  }
})  //加载组件Json Schema

Vue.component(twoField.name, twoField)  //注册组件

// 注册属性编辑框
PERegister.registerCPEditor('placeholder1', 'placeholder1-editor',
  PEFactory.createInputTextEditor('placeholder1', '占位内容2'))

PERegister.registerCPEditor('requiredHint1', 'requiredHint1-editor',
  PEFactory.createInputTextEditor('requiredHint1', '必填内容提示2'))

PERegister.registerCPEditor('input1Width', 'input1Width-editor',
  PEFactory.createInputTextEditor('input1Width', '文本框宽度1'))

PERegister.registerCPEditor('input2Width', 'input2Width-editor',
  PEFactory.createInputTextEditor('input2Width', '文本框宽度2'))

PERegister.registerCPEditor('unit1', 'unit1-editor',
  PEFactory.createInputTextEditor('unit1', '单位1'))

PERegister.registerCPEditor('unit2', 'unit2-editor',
  PEFactory.createInputTextEditor('unit2', '单位2'))

PERegister.registerCPEditor('inputRegular1', 'inputRegular1-editor',
  PEFactory.createInputTextEditor('inputRegular1', '正则校验文本框1'))

PERegister.registerCPEditor('inputRegular2', 'inputRegular2-editor',
  PEFactory.createInputTextEditor('inputRegular2', '正则校验文本框2'))


PERegister.registerEPEditor('onChange1', 'onChange1-editor',
  PEFactory.createEventHandlerEditor('onChange1', ['val']))

PERegister.registerEPEditor('onChange2', 'onChange2-editor',
  PEFactory.createEventHandlerEditor('onChange2', ['val']))

PERegister.registerEPEditor('onBlur1', 'onBlur1-editor',
  PEFactory.createEventHandlerEditor('onBlur1', ['val']))

PERegister.registerEPEditor('onBlur2', 'onBlur2-editor',
  PEFactory.createEventHandlerEditor('onBlur2', ['val']))